<template>
  <div class="layout-footer">
    <img
      alt="Logo"
      src="../../../public/images/sespa/brasaoSespa.png"
      height="40"
      class="mr-2"
    />
  </div>
</template>

<script>
export default {
  name: "AppFooter",
  methods: {
  },
};
</script>